<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 24 24">
    <path d="M 15.984 17.016 v -6 c 0 -2.484 -1.5 -4.5 -3.984 -4.5 s -3.984 2.016 -3.984 4.5 v 6 h 7.969 Z M 18 15.984 l 2.016 2.016 v 0.984 h -16.031 v -0.984 l 2.016 -2.016 v -4.969 c 0 -3.094 1.641 -5.625 4.5 -6.328 v -0.703 c 0 -0.844 0.656 -1.5 1.5 -1.5 s 1.5 0.656 1.5 1.5 v 0.703 c 2.859 0.703 4.5 3.281 4.5 6.328 v 4.969 Z M 12 21.984 c -1.078 0 -2.016 -0.891 -2.016 -1.969 h 4.031 c 0 1.078 -0.938 1.969 -2.016 1.969 Z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-bell-o.html